
<div>
    <app-bar :title="event.title"/>

    <v-layout>
        <v-progress-linear
            v-if="overlay"
            absolute
            indeterminate
        ></v-progress-linear>

        <div class="pt-8 pb-12 px-8">
            <div class="pb-10">
                <v-btn
                    v-if="permitted('admin_club_management')"
                    @click="edit"
                    class="sm mr-5"
                    color="primary"
                >{{ t('general_action_edit') }}
                </v-btn>
                <v-btn
                    v-if="permitted('admin_club_management')"
                    class="sm mr-5"
                    color="primary"
                    outlined
                    @click.prevent="suspend(event)"
                >
                    {{ event.enabled ? t('general_action_suspend') : t('general_action_unsuspend') }}
                </v-btn>
                <confirm-modal
                    v-if="permitted('admin_club_management')"
                    :title="t('general_title_confirm_action')"
                    @agree="del(event)"
                >
                    <template #default="{ on, attrs }">
                        <v-btn
                            class="sm"
                            color="orange"
                            outlined
                            v-on="on"
                            v-bind="attrs"
                        >{{ t('general_action_delete') }}</v-btn>
                    </template>
                </confirm-modal>
            </div>
            <div class="float-left mr-10" style="width: 394px; max-width: 394px">
                <img
                    v-if="event.photoUrl"
                    :src="event.photoUrl"
                    width="150"
                />
                <div class="form-subtitle">{{ t('club_event_label_description') }}:</div>
                <div class="form-subtitle-description" v-html="event.description"></div>
            </div>
            <div class="float-left" style="max-width: calc(100% - 434px)">
                <card-unit :items="items()">
                    <template #title>{{ t('club_event_label_id') }}: {{ event.id }}</template>
                </card-unit>
            </div>
        </div>
    </v-layout>
</div>
